export default __webpack_public_path__ + "static/media/student-1.2231ea59.jpeg";